import React, { Fragment, useState, useEffect } from "react";
import { backend, API_URL } from "../../../config";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Modal,
  CircularProgress,
  Container,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import RangeDates from "./RangeDates";
import UploadFile from "./UploadFile";
import Difference from "./Difference";
import ReceiptPreview from "./ReceiptPreview";
import ReceiptConvert from "./ReceiptConvert";

import readXlsxFile from "read-excel-file";
import writeXlsxFile from "write-excel-file";
import ReceiptViewer from "./ReceiptViewer";
import { Link } from "react-router-dom/cjs/react-router-dom";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columnsReceiptRD = [
  {
    id: "purchaseDate",
    label: "Purchase Date",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "receiptNumber",
    label: "Receipt Number",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "sales",
    label: "Total",
    exposed: false,
    exposedAs: "input",
  },
  {
    id: "name",
    label: "Custom name",
    exposed: true,
    exposedAs: "input",
  },
];

const columnsReceiptViewer = [
  {
    id: "product",
    label: "Product",
  },
  {
    id: "quantity",
    label: "Quantity",
  },
  {
    id: "unit_type",
    label: "Unit Type",
  },
  {
    id: "total",
    label: "Total",
  },
];

const columnsReceiptOld = [
  {
    id: "line",
    label: "Line",
  },
  {
    id: "product",
    label: "UPC",
  },
  {
    id: "item_code",
    label: "Item",
  },
  {
    id: "product_name",
    label: "Description",
  },
  {
    id: "price",
    label: "Price",
  },
  {
    id: "unit_type",
    label: "C/U",
  },
  {
    id: "quantity",
    label: "Qty",
  },
  {
    id: "total",
    label: "Total",
  },
  {
    id: "t",
    label: "T",
  },
];

const receiptHeaderOld = [
  [
    "2020-12-04T05:43:19.000Z",
    null,
    null,
    null,
    null,
    "Branch 43 Los Angeles,CA",
    null,
    null,
    null,
  ],
  ["Click here to print", null, null, null, null, null, null, null, null],
  ["Download Excel version", null, null, null, null, null, null, null, null],
  [
    null,
    null,
    null,
    null,
    null,
    "Import Receipt",
    "View All Quotes",
    null,
    "View A Quote",
  ],
  [
    null,
    "Branch: 43 - 5333 West Jefferson Blvd, Los Angeles, CA 90016-3713",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  [
    null,
    "Phone: 323-964-1220  Fax: 323-964-1230",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  ["Invoice", null, 158798, null, null, null, null, null, null],
  [
    "Customer",
    null,
    4323553,
    null,
    "Order Date",
    null,
    "2020-12-04T00:00:00.000Z",
    null,
    null,
  ],
  [
    "Business Name",
    null,
    "FRIENDLY FOODS INC",
    null,
    "Order Amount",
    null,
    8413.81,
    null,
    null,
  ],
  [
    "Address",
    null,
    "8410,SALT LAKE AVE",
    null,
    "Amount Paid",
    null,
    0,
    null,
    null,
  ],
  [
    null,
    null,
    "CUDAHY, CA 902015818",
    null,
    "Balance Due",
    null,
    8413.81,
    null,
    null,
  ],
  [
    "Phone",
    null,
    3236535900,
    null,
    "Convert From Quote",
    null,
    140372,
    null,
    null,
  ],
  [null, null, null, null, null, null, null, null, null],
  [null, null, null, null, null, null, null, null, null],
];

const columnsWidthOld = [
  { width: 80 },
  { width: 65.14 },
  { width: 20.86 },
  { width: 28.57 },
  { width: 19.29 },
  { width: 24.86 },
  { width: 13.14 },
  { width: 7.43 },
  { width: 11.29 },
  { width: 20.86 },
];

export const ReceiptDifference = (props) => {
  const classes = useStyles();
  const steps = {
    receipt: ["Select Orders", "Difference Generated"],
    upload: ["Upload CSV", "Preview Data"],
    convert: ["Receipt API"],
    viewer: ["Receipt Viewer"],
  };
  const cDate = new Date();
  const cDateString = new Date(
    cDate.getTime() - cDate.getTimezoneOffset() * 60000,
  ).toISOString();

  let yDate = new Date();
  yDate.setDate(yDate.getDate() - 1);

  const query = new URLSearchParams(props?.location?.search);

  const urlAction = query.get("action");

  const [activeStep, setActiveStep] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  // const [responseModal, setResponseModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);

  const [action, setAction] = useState(urlAction || "receipt"); // receipt, upload, convert
  const [pricingType, setPricingType] = useState("shelf"); // shelf or contract
  const [showPricingDifferences, setShowPricingDifferences] = useState(false);
  const [currentPricing, setCurrentPricing] = useState(true);
  const [dateRange, setDateRange] = useState([cDate, cDate]);
  const [dateRangeRq, setDateRangeRq] = useState([cDate, cDate]);
  const [orders, setOrders] = useState([]);
  const [ordersSelected, setOrdersSelected] = useState([]);
  const [priceMargin, setPriceMargin] = useState(5);
  const [receiptData, setReceiptData] = useState([]);
  const [receiptDataImported, setReceiptDataImported] = useState(false);
  const [receiptDataMapped, setReceiptDataMapped] = useState([]);
  const [receiptHeadersIndex, setReceiptHeadersIndex] = useState(0);
  const [receiptLines, setReceiptLines] = useState([]);
  const [receiptLinesLoaded, setReceiptLinesLoaded] = useState(false);
  const [receiptName, setReceiptName] = useState("receipt" + cDateString);
  const [receipts, setReceipts] = useState([]);
  const [receiptsSelected, setReceiptsSelected] = useState([]);
  const [receiptSelected, setReceiptSelected] = useState(null);
  const [receiptsRq, setReceiptsRq] = useState([]);
  const [receiptsRqLoaded, setReceiptsRqLoaded] = useState(false);
  const [receiptsRqSelected, setReceiptsRqSelected] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehousesSelected, setWarehousesSelected] = useState("");

  const handleChangeAction = (type) => (e) => {
    if (action !== type) {
      setAction(type);
      props.history.replace(`/receiptDifference?action=${type}`);
    }
  };

  const handleChangeCurrentPricing = (e) => {
    const { checked } = e.target;
    setCurrentPricing(checked);
  };

  const handleChangePricingType = (type) => (e) => {
    if (pricingType !== type) {
      setPricingType(type);

      if (type === "contract") {
        setShowPricingDifferences(false);
      }
    }
  };

  const handleChangeShowPricingDifferences = (e) => {
    const { checked } = e.target;
    setShowPricingDifferences(checked);
  };

  const handleChangeOrders = (e, value) => {
    // const { value } = e.target;
    setOrdersSelected(value);
  };

  const handleChangePriceMargin = (e) => {
    const { value } = e.target;
    setPriceMargin(value);
  };

  const handleChangeRangeDate = (e) => {
    const { name, value } = e.target;
    setOrders([]);
    setOrdersSelected([]);
    setDateRange((prevState) => {
      if (name === "start_date") {
        prevState[0] = value;
      } else {
        prevState[1] = value;
      }
      return [prevState[0], prevState[1]];
    });
  };

  const handleChangeRangeDateRq = (e) => {
    const { name, value } = e.target;
    setDateRangeRq((prevState) => {
      if (name === "start_date") {
        prevState[0] = value;
      } else {
        prevState[1] = value;
      }
      return [prevState[0], prevState[1]];
    });
  };

  const handleChangeReceipts = (e, value) => {
    setReceiptsSelected(value);
  };

  const handleChangeReceiptsRq = (e, value) => {
    setReceiptsRqSelected(
      value.map((item) => ({
        ...item,
        name: `Receipt #${item.receiptNumber} - $${item.sales} (${item.purchaseDate})`,
      })),
    );
  };

  const handleChangeReceipt = (e, value) => {
    setReceiptLinesLoaded(false);
    setReceiptLines([]);
    setReceiptSelected(value);
  };

  const handleChangeReceiptsRqSelected = (e) => {
    const { checked, name, value } = e.target;
    const [columnId, rowId] = name.split("-");

    const columnData = columnsReceiptRD.find((item) => item.id === columnId);
    if (columnData.exposed) {
      setReceiptsRqSelected((prevState) =>
        prevState.map((item, index) => {
          if (+rowId === index) {
            const columnValue = columnData.hasOwnProperty("exposedAs")
              ? columnData.exposedAs === "checkbox"
                ? checked
                : value
              : value;
            item[columnId] = columnValue;

            return item;
          } else {
            return item;
          }
        }),
      );
    }
  };

  const handleChangeReceiptData = (data, file) => {
    let dataImported = [];

    switch (file.type) {
      case "text/csv":
        data
          .map((item) => item.data)
          .forEach((item) => {
            if (item.length > 1) {
              dataImported.push(item);
            }
          });
        setReceiptData(dataImported);
        setReceiptDataImported(true);

        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        readXlsxFile(file).then((data) => {
          data.forEach((item) => {
            if (item.length > 1) {
              dataImported.push(item);
            }
          });
          setReceiptData(dataImported);
          setReceiptDataImported(true);
        });

        break;
      default:
        setErrorInfo({
          error: true,
          message:
            "The imported file it's not compatible. Please use a .csv or .xlsx file.",
        });
    }

    if (!errorInfo.error) {
      const receiptFilename =
        file.name.substring(0, file.name.length - 4) || "receipt";
      setReceiptName(`${receiptFilename} (${cDateString})`);
    }
  };

  const handleChangeReceiptDataMapped = (data) => {
    setReceiptDataMapped(data);
  };

  const handleChangeReceiptName = (e) => {
    const { value } = e.target;
    setReceiptName(value);
  };

  const handleChangeWarehouses = (e) => {
    const { value } = e.target;
    setWarehousesSelected(value);
  };

  const handleClickOldExport = async () => {
    const importedDateTop = receiptData[0][0];

    const importedInvoiceIndex = receiptData.findIndex((item) =>
      ["invoice"].includes(String(item[0]).toLowerCase()),
    );

    const importedInvoice =
      importedInvoiceIndex === -1
        ? receiptData[10][2]
        : receiptData[importedInvoiceIndex][2];

    const importedDateOrderIndex = receiptData.findIndex((item) =>
      ["order date"].includes(String(item[4]).toLowerCase()),
    );

    const importedDateOrder =
      importedDateOrderIndex === -1
        ? receiptData[11][6]
        : receiptData[importedDateOrderIndex][6];

    const receiptDataStripped = receiptData.filter(
      (item, index) => index >= receiptHeadersIndex,
    );

    const receiptDataMerged = [...receiptHeaderOld, ...receiptDataStripped];

    const receiptDataExport = receiptDataMerged.map((row, rowIndex) =>
      row.map((cell, cellIndex) => {
        let cellObj = { value: cell };

        if (rowIndex === 0 && cellIndex === 0) {
          cellObj.format = "dd/mm/yyyy HH:MM";
          cellObj.type = Date;
          cellObj.value = importedDateTop || cDateString;
        }

        if (rowIndex === 6 && cellIndex === 2) {
          cellObj.value = importedInvoice || "Not Found";
        }

        if (rowIndex === 7 && cellIndex === 6) {
          cellObj.format = "dd/mm/yyyy";
          cellObj.type = Date;
          cellObj.value = importedDateOrder || cDateString;
        }

        return cellObj;
      }),
    );

    await writeXlsxFile(receiptDataExport, {
      columns: columnsWidthOld,
      fileName: `${receiptName}.xlsx`,
    });
  };

  const handleClickOldExportViewer = async () => {
    const receiptSelectedDate = new Date(receiptSelected.date);
    const importedDateTop = receiptSelectedDate;
    const importedInvoice = null;
    const importedDateOrder = receiptSelectedDate;

    const columnsHeader = columnsReceiptOld.map((item) => item.label);

    const receiptLinesFull = receiptLines.map((item, index) => [
      index + 1,
      item.product,
      item.item_code,
      item.product_name,
      +(item.total / item.quantity).toFixed(2),
      item.unit_type,
      item.quantity,
      item.total,
      "",
    ]);

    const receiptDataMerged = [
      ...receiptHeaderOld,
      columnsHeader,
      ...receiptLinesFull,
    ];

    const receiptDataExport = receiptDataMerged.map((row, rowIndex) =>
      row.map((cell, cellIndex) => {
        let cellObj = { value: cell };

        if (rowIndex === 0 && cellIndex === 0) {
          cellObj.format = "yyyy/mm/dd HH:MM";
          cellObj.type = Date;
          cellObj.value = importedDateTop || cDate;
        }

        if (rowIndex === 6 && cellIndex === 2) {
          cellObj.value = importedInvoice || "Not Found";
        }

        if (rowIndex === 7 && cellIndex === 6) {
          cellObj.format = "yyyy/mm/dd";
          cellObj.type = Date;
          cellObj.value = importedDateOrder || cDate;
        }

        if ((rowIndex === 8 || rowIndex === 10) && cellIndex === 6) {
          cellObj.value = receiptSelected.total;
        }

        return cellObj;
      }),
    );

    await writeXlsxFile(receiptDataExport, {
      columns: columnsWidthOld,
      fileName: `${receiptSelected.description} (${cDateString}).xlsx`,
    });
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the receipt <b>{receiptName}</b>
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving receipt information <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the receipt information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Receipt information have been successfully saved
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const confirmModalContentConvert = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to convert the receipts selected?
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequestConvert()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Converting receipts <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while converting the receipts selected
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The receipts selected have been successfully saved
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  // const toggleResponseModal = () => setResponseModal(!responseModal);

  /* const responseModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an error adding the receipt <b>{receiptName}</b>
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
        </>
      ) : (
        <>
          Receipt <b>{receiptName}</b> has been successfully added
        </>
      )}
      <div align="right">
        <Button
          variant="contained"
          color="primary"
          onClick={() => resolveRequest()}
          className={classes.button}
        >
          Continue
        </Button>
      </div>
    </div>
  ); */

  // todo: rewrite getStepContent functionality
  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return action === "receipt" ? (
          <RangeDates
            {...props}
            currentPricing={currentPricing}
            dateRange={dateRange}
            orders={orders}
            ordersSelected={ordersSelected}
            priceMargin={priceMargin}
            receipts={receipts}
            receiptsSelected={receiptsSelected}
            pricingType={pricingType}
            showPricingDifferences={showPricingDifferences}
            handleChangeCurrentPricing={handleChangeCurrentPricing}
            handleChangeRangeDate={handleChangeRangeDate}
            handleChangeOrders={handleChangeOrders}
            handleChangeReceipts={handleChangeReceipts}
            handleChangePriceMargin={handleChangePriceMargin}
            handleChangePricingType={handleChangePricingType}
            handleChangeShowPricingDifferences={
              handleChangeShowPricingDifferences
            }
          />
        ) : action === "upload" ? (
          <UploadFile
            {...props}
            errorInfo={errorInfo}
            receiptData={receiptData}
            receiptHeadersIndex={receiptHeadersIndex}
            setErrorInfo={setErrorInfo}
            handleChangeReceiptData={handleChangeReceiptData}
            handleClickOldExport={handleClickOldExport}
          />
        ) : action === "convert" ? (
          <ReceiptConvert
            {...props}
            columns={columnsReceiptRD}
            dateRangeRq={dateRangeRq}
            receiptsRq={receiptsRq}
            receiptsRqSelected={receiptsRqSelected}
            receiptsRqLoaded={receiptsRqLoaded}
            handleChangeRangeDateRq={handleChangeRangeDateRq}
            handleChangeReceiptsRq={handleChangeReceiptsRq}
            handleChangeReceiptsRqSelected={handleChangeReceiptsRqSelected}
          />
        ) : (
          <ReceiptViewer
            {...props}
            columns={columnsReceiptViewer}
            receipts={receipts}
            receiptSelected={receiptSelected}
            receiptLines={receiptLines}
            receiptLinesLoaded={receiptLinesLoaded}
            pricingType={pricingType}
            handleChangeReceipt={handleChangeReceipt}
            handleChangePricingType={handleChangePricingType}
            handleClickOldExportViewer={handleClickOldExportViewer}
          />
        );
      case 1:
        return action === "receipt" ? (
          <Difference
            {...props}
            currentPricing={currentPricing}
            dateRange={dateRange}
            orders={orders}
            ordersSelected={ordersSelected}
            receiptsSelected={receiptsSelected}
            priceMargin={priceMargin}
            pricingType={pricingType}
            showPricingDifferences={showPricingDifferences}
          />
        ) : action === "upload" ? (
          <ReceiptPreview
            {...props}
            receiptData={receiptData}
            receiptName={receiptName}
            warehouses={warehouses}
            warehousesSelected={warehousesSelected}
            handleChangeReceiptDataMapped={handleChangeReceiptDataMapped}
            handleChangeReceiptName={handleChangeReceiptName}
            handleChangeWarehouses={handleChangeWarehouses}
          />
        ) : (
          <></>
        );
      default:
        throw new Error("Unknown step");
    }
  };

  const handleNext = () => {
    if (activeStep !== steps[action].length - 1) {
      setActiveStep(activeStep + 1);
    } else {
      toggleConfirmModal();
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const resolveRequest = () => {
    setFinishedFlag(false);
    toggleConfirmModal();

    if (!errorInfo.error) {
      if (action === "convert") {
        window.location.href = "/receiptDifference?action=viewer";
      } else {
        props.history.push("/orders");
      }
    }
  };

  const sendRequest = async () => {
    setLoadingFlag(true);
    const receiptDataTotal = receiptDataMapped.reduce(
      (prev, item) => prev + item.total,
      0,
    );
    const receiptObj = {
      description: receiptName,
      total: +receiptDataTotal.toFixed(2),
      warehouse: 2,
      pricing_type: "s",
    };
    await backend
      .post(`${API_URL}receipts/`, receiptObj)
      .then(({ data }) => {
        const receiptId = data.id;
        saveReceiptData(receiptId);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  const sendRequestConvert = async () => {
    setLoadingFlag(true);

    const receiptsMapped = receiptsRqSelected.map((item) => ({
      purchaseDate: item.purchaseDate,
      branch: item.branch,
      receiptNumber: item.receiptNumber,
      description: item.name,
    }));

    const payload = JSON.stringify(receiptsMapped);

    await backend
      .post(`${API_URL}convertrdinvoice/`, payload)
      .then(({ data }) => {
        setLoadingFlag(false);
        setFinishedFlag(true);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  const saveReceiptData = async (receiptId) => {
    const receiptDataArray = receiptDataMapped.map((item) => ({
      ...item,
      receipt: receiptId,
    }));
    await backend
      .post(`${API_URL}receiptlines/`, receiptDataArray)
      .then(({ data }) => {
        setLoadingFlag(false);
        setFinishedFlag(true);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
        deleteReceipt(receiptId);
      });
  };

  const deleteReceipt = async (receiptId) => {
    await backend
      .delete(`${API_URL}receipts/`, receiptId)
      .then(() => {})
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  useEffect(() => {
    const getWarehouses = () => {
      setWarehouses([
        {
          id: 2,
          name: "Restaurant Depot",
          csv_header_mapping: {
            UPC: "product",
            Qty: "quantity",
            "C/U": "unit_type",
            "Ext. Value": "total",
          },
          unit_type_mapping: {},
        },
      ]);
    };

    /* const getWarehouses = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        if (data.length) {
          setWarehouses(data);
        }
      });
    };

    const getReceiptLineHeaders = async () => {
      await backend.get(`${API_URL}receipts/1`).then(({ data }) => {
        console.log("lineheaders", data);
      });
    };

    const getReceiptLineUnitTypeMappings = async () => {
      await backend.get(`${API_URL}receiptlines?no_page=1`).then(({ data }) => {
        console.log("lineunittypemappings", data);
      });
    }; */

    getWarehouses();
    // getReceiptLineHeaders();
    // getReceiptLineUnitTypeMappings();
  }, []);

  useEffect(() => {
    let ignore = false;

    const getReceipts = async () => {
      setReceipts([]);
      setReceiptsSelected([]);
      setReceiptSelected(null);

      await backend
        .get(`${API_URL}receipts?no_page=1&pricing_type=${pricingType}`)
        .then(({ data }) => {
          if (!ignore && data.length) {
            setReceipts(data);
          }
        });
    };

    getReceipts();

    return () => {
      ignore = true;
    };
  }, [pricingType]);

  useEffect(() => {
    const getOrders = async () => {
      let startDate = new Date(dateRange[0]);
      let endDate = new Date(dateRange[1]);

      const startDateParam = new Date(
        startDate.getTime() - startDate.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];
      const endDateParam = new Date(
        endDate.getTime() - endDate.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];

      await backend
        .get(
          `${API_URL}orders?no_page=1&start_date=${startDateParam}&end_date=${endDateParam}`,
        )
        .then(({ data }) => {
          if (data.length) {
            setOrders(data);
            setOrdersSelected(data);
          }
        });
    };

    if (dateRange[0] !== null && dateRange[1] !== null) {
      getOrders();
    }
  }, [dateRange]);

  useEffect(() => {
    const getReceiptsRD = async () => {
      let startDate = new Date(dateRangeRq[0]);
      let endDate = new Date(dateRangeRq[1]);

      const startDateParam = new Date(
        startDate.getTime() - startDate.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];
      const endDateParam = new Date(
        endDate.getTime() - endDate.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];

      await backend
        .get(
          `${API_URL}rdinvoicesummaries?no_page=1&start_date=${startDateParam}&end_date=${endDateParam}`,
        )
        .then(({ data }) => {
          if (data.length) {
            setReceiptsRq(data);
            // setReceiptsRqSelected(data);
          }
          setReceiptsRqLoaded(true);
        });
    };

    if (dateRangeRq[0] !== null && dateRangeRq[1] !== null) {
      setReceiptsRq([]);
      setReceiptsRqLoaded(false);
      setReceiptsRqSelected([]);
      getReceiptsRD();
    }
  }, [dateRangeRq]);

  useEffect(() => {
    if (receiptDataImported) {
      if (!receiptData.length) {
        setErrorInfo({
          error: true,
          message:
            "The imported file couldn't be processed (it didn't generate any data to be imported).",
        });
      } else {
        const headersIndex = receiptData.findIndex((item) =>
          ["line", "upc"].includes(String(item[0]).toLowerCase()),
        );

        setReceiptHeadersIndex(headersIndex);

        if (headersIndex === -1) {
          setErrorInfo({
            error: true,
            message:
              "The imported file couldn't be processed (couldn't find the headers from the imported data).",
          });
        }
      }
    }
  }, [receiptData, receiptDataImported]);

  useEffect(() => {
    const getReceiptLines = async () => {
      await backend
        .get(
          `${API_URL}receiptlines?no_page=1&product_info=1&receipt=${receiptSelected.id}`,
        )
        .then(({ data }) => {
          setReceiptLinesLoaded(true);
          setReceiptLines(data);
        });
    };

    if (receiptSelected !== null) {
      getReceiptLines();
    }
  }, [receiptSelected]);

  useEffect(() => {
    if (props.location.state) {
      setActiveStep(1);
    }
  }, [props]);

  return (
    <Container>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {action === "upload" ? confirmModalContent : confirmModalContentConvert}
      </Modal>
      {/* <Modal open={responseModal} onClose={toggleResponseModal}>
            {responseModalContent}
          </Modal> */}
      {activeStep === 0 ? (
        <Stack direction="row" spacing={1} justifyContent="center">
          <Button
            style={{ marginBottom: 10 }}
            variant="contained"
            color={action === "receipt" ? "primary" : "inherit"}
            onClick={handleChangeAction("receipt")}
          >
            Receipt Difference
          </Button>
          <Link
            to="/receipt/upload"
            style={{ textDecoration: "none", color: "black" }}
          >
            <Button
              style={{ marginBottom: 10 }}
              variant="contained"
              color={action === "upload" ? "primary" : "inherit"}
              onClick={handleChangeAction("upload")}
            >
              Upload Receipt
            </Button>
          </Link>
          <Button
            style={{ marginBottom: 10 }}
            variant="contained"
            color={action === "convert" ? "primary" : "inherit"}
            onClick={handleChangeAction("convert")}
          >
            Receipt API
          </Button>
          <Button
            style={{ marginBottom: 10 }}
            variant="contained"
            color={action === "viewer" ? "primary" : "inherit"}
            onClick={handleChangeAction("viewer")}
          >
            Receipt Viewer
          </Button>
        </Stack>
      ) : (
        <></>
      )}
      <Typography component="h6" variant="h6" align="center">
        Receipt Difference
      </Typography>
      <Stepper activeStep={activeStep} className={`${classes.stepper} noprint`}>
        {steps[action].map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Fragment>
        {activeStep === steps[action].length ? (
          <Fragment></Fragment>
        ) : (
          <Fragment>
            {getStepContent(activeStep)}
            <div className={classes.buttons}>
              {activeStep !== 0 && (
                <Button onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              )}
              {(activeStep === steps[action].length - 1 &&
                action === "receipt") ||
              action === "viewer" ? (
                <></>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                  disabled={
                    (action === "receipt" && !ordersSelected.length) ||
                    (action === "convert" && !receiptsRqSelected.length) ||
                    errorInfo.error
                  }
                >
                  {activeStep === steps[action].length - 1 ? "Finish" : "Next"}
                </Button>
              )}
            </div>
          </Fragment>
        )}
      </Fragment>
    </Container>
  );
};

export default ReceiptDifference;
